'use client';

/* eslint-disable react/button-has-type */
import React from 'react';
import useGlobalState from '@hooks/useGlobalState';
import dynamic from 'next/dynamic';
import { BrandPageServerProps } from '@models/brand';
import SubSkeleton03 from '@wconcept/wconcept-ui-renewal/src/components/molecules/_skeleton/SubSkeleton03';
import BrandNewTemplate from '@wconcept/wconcept-ui-renewal/components/templates/BrandNewTemplate';
import { LpScrollStyle } from '@wconcept/wconcept-ui-renewal/hooks/lp-scroll';
import DesktopSkeleton from '@components/pages/common/DesktopSkeleton';
import { BrandPageNone } from './BrandPageNone';

const BrandMobileCornerList = dynamic(() => import('../BrandPageCornerList'), {
  ssr: false,
  loading: () => <SubSkeleton03 />,
});
const BrandDesktopCornerList = dynamic(() => import('../BrandPageCornerList'), {
  ssr: false,
  loading: () => <DesktopSkeleton />,
});

const BrandDesktopProductList = dynamic(
  () => import('../BrandPageProductList'),
  {
    ssr: false,
    loading: () => null,
  }
);
const BrandMobileProductList = dynamic(
  () => import('../BrandPageProductList'),
  {
    ssr: false,
    loading: () => <SubSkeleton03 />,
  }
);

function BrandPageContent() {
  const { isMobile, initialData } = useGlobalState<BrandPageServerProps>();

  if (initialData?.originalProductTotal === 0 || !initialData?.brandInfo) {
    return <BrandPageNone />;
  }

  return (
    <BrandNewTemplate className="brand-template">
      <LpScrollStyle />
      <div className="contents-wrap">
        {isMobile ? (
          <BrandMobileCornerList id="brandConnerList" />
        ) : (
          <BrandDesktopCornerList id="brandConnerList" />
        )}
      </div>
      {isMobile ? (
        <BrandMobileProductList id="brandProductList" />
      ) : (
        <BrandDesktopProductList id="brandProductList" />
      )}
    </BrandNewTemplate>
  );
}

export default BrandPageContent;
